<div class="configuration-page">
  <div class="configuration-page-header">
    <div class="tabs-wrapper">
      <div
        class="tab"
        (click)="this.setActiveTab('ORV')"
        [ngClass]="{'active': this.activeTab === 'ORV'}"
      >
        <p>ORV</p>
      </div>
      <div
        class="tab"
        (click)="this.setActiveTab('GG')"
        [ngClass]="{'active': this.activeTab === 'GG'}"
      >
        <p>GG</p>
      </div>
    </div>
    <div class="configuration-page-header-logout">
      <button
        type="button"
        class="primary primary-config-button"
        (click)="logout()"
      >
        {{ 'Login.LogoutButton' | translate }}
      </button>
    </div>
  </div>
  <div class="product-config-wrapper" *ngIf="this.activeTab === 'ORV'">
    <app-configuration-orv-page></app-configuration-orv-page>
  </div>
  <div class="product-config-wrapper" *ngIf="this.activeTab === 'GG'">
    <app-configuration-gg-page></app-configuration-gg-page>
  </div>
</div>
